import { MISSING_KEY } from "@warda/library-ui/constants";
import parseJWT from "../../utils/parseJWT";
export const SHAREPAGE_TOKEN = "token";
export var AccessStatus;
(function (AccessStatus) {
    AccessStatus[AccessStatus["VERIFYING"] = 0] = "VERIFYING";
    AccessStatus[AccessStatus["LOGIN_REQUIRED"] = 401] = "LOGIN_REQUIRED";
    AccessStatus[AccessStatus["GRANTED"] = 200] = "GRANTED";
    AccessStatus[AccessStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    AccessStatus[AccessStatus["SYSTEM_ERROR"] = 500] = "SYSTEM_ERROR";
})(AccessStatus || (AccessStatus = {}));
export const HTML_ID_DRAWERS = "portalIdDrawers";
export const DRAWER_WIDTH = 400;
export var ViewMode;
(function (ViewMode) {
    ViewMode["NAVIGATION"] = "NAVIGATION";
    ViewMode["SEARCH"] = "SEARCH";
})(ViewMode || (ViewMode = {}));
export const FileTypeId = {
    FOLDER: MISSING_KEY,
    DOCUMENT: "DOCUMENT",
    IMAGE: "IMAGE",
    VIDEO: "VIDEO",
    OTHER: "OTHER",
};
export const FileTypeIcon = {
    [FileTypeId.FOLDER]: "folder",
    [FileTypeId.DOCUMENT]: "insert_drive_file",
    [FileTypeId.IMAGE]: "image",
    [FileTypeId.VIDEO]: "videocam",
    [FileTypeId.OTHER]: "insert_drive_file",
};
export const FileTypeText = {
    [FileTypeId.FOLDER]: "Folders",
    [FileTypeId.DOCUMENT]: "Documents",
    [FileTypeId.IMAGE]: "Images",
    [FileTypeId.VIDEO]: "Videos",
    [FileTypeId.OTHER]: "Other",
};
export const getTenantId = () => {
    var _a;
    try {
        const query = new URLSearchParams(window.location.search);
        const token = query.get(SHAREPAGE_TOKEN);
        return (_a = parseJWT(token)) === null || _a === void 0 ? void 0 : _a.tenantId;
    }
    catch {
        return "";
    }
};
export var ATTRIBUTES_KEY;
(function (ATTRIBUTES_KEY) {
    ATTRIBUTES_KEY["NAME"] = "name";
    ATTRIBUTES_KEY["SIZE"] = "sizeInBytes";
    ATTRIBUTES_KEY["TYPE"] = "mimeType";
    ATTRIBUTES_KEY["CREATED"] = "created";
})(ATTRIBUTES_KEY || (ATTRIBUTES_KEY = {}));
export const ATTRIBUTES = [
    {
        id: ATTRIBUTES_KEY.NAME,
        label: "Name",
        width: 250,
        sortable: true,
    },
    {
        id: ATTRIBUTES_KEY.CREATED,
        label: "Created",
        width: 150,
        sortable: true,
    },
    {
        id: ATTRIBUTES_KEY.SIZE,
        label: "Size",
        width: 150,
        sortable: false,
    },
    {
        id: ATTRIBUTES_KEY.TYPE,
        label: "Extension",
        width: 80,
        sortable: false,
    },
];
export const TOKEN_EXPIRED_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes
